import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { appRoutes } from '../../../path';
import {
  IDashboardCreateMutation,
  IDashboardCreateMutationVariables,
} from '../../../utils/apollo/graphqlSchema';
import { CREATE_DASHBOARD } from '../../../utils/apollo/dashboards';
import printGraphqlErrors from '../../../utils/apollo/printGraphqlErrors';
import { assertNotNil } from '../../../utils/types';
import { GetStartedLinkItem, GetStartedLinks } from './GetStartedLinks';

const GetStartedActionLinks = () => {
  const navigate = useNavigate();

  const handleMutationComplete = ({
    dashboardCreate,
  }: IDashboardCreateMutation) => {
    const { entity, errors } = dashboardCreate;
    if (printGraphqlErrors(errors)) {
      return;
    }

    assertNotNil(entity);

    navigate(appRoutes.dashboard.generateLink(entity.baseId));
  };

  const [runCreateDashboard, { loading }] = useMutation<
    IDashboardCreateMutation,
    IDashboardCreateMutationVariables
  >(CREATE_DASHBOARD, {
    onCompleted: handleMutationComplete,
  });

  const createDashboard = useCallback(() => {
    runCreateDashboard({
      variables: {
        input: {
          name: 'Untitled Dashboard',
          analyses: [],
          description: '',
        },
      },
    });
  }, [runCreateDashboard]);

  return (
    <GetStartedLinks title={'Actions'}>
      <GetStartedLinkItem
        type="link"
        label={'Create a Report'}
        url={appRoutes.report.query}
      />
      <GetStartedLinkItem
        type="button"
        label={'Create a New Dashboard'}
        onClick={createDashboard}
        disabled={loading}
      />
    </GetStartedLinks>
  );
};

export default GetStartedActionLinks;
